import { useSelector } from 'react-redux';
import { IMetadata } from 'components/common/element-data/types';
import { prepareMetadataSettings } from 'components/common/element-data/functions';

export type metadataUsage = 'info' | 'viewer' | 'concierge' | 'default';
export const useElementMetadataSettings = (usage: metadataUsage, ignoreOrder?: boolean) => {
    const metadataSettingsRaw = useSelector(
        (state: any) => state.auth?.userInfo?.brandThemeProperties?.brand_theme_tile_element_metadata,
    );
    const ownersConfiguration = useSelector((state: any) => state.auth.configuration.owners);
    let metadataSettings: any = {};

    try {
        metadataSettings = JSON.parse(metadataSettingsRaw) as IMetadata;
    } catch (e) {}

    return prepareMetadataSettings(metadataSettings, ownersConfiguration, usage, ignoreOrder);
};
